import { useMutation, useQuery } from "@apollo/client";
import { AlertConfirm, CustomisedTable } from "components/common";
import { useEffect, useState } from "react";
import { initialBudgetFilters } from "utils/helpers";
import { transactionStyles } from "views/Transactions/transactionStyles";
import { Button, Grid, Typography, Box } from "@material-ui/core";
import { UPDATE_BUDGET } from "graphql/mutations/budgets";
import { GET_BEHAVIORS_QUERY } from "graphql/queries/behaviors";
import { behaviorColumns } from "components/columns/behaviors";
import { EvaluateBehavior } from "./EvaluateBehavior";

const initialCurrentState = {
  current: null,
  open: false,
  openApprove: false,
  message: "Are you sure you want to approve",
};

export const BehaviorPIP = () => {
  const classes = transactionStyles();
  const [filters] = useState(initialBudgetFilters);
  const [currentBudget, setCurrentBudget] = useState(initialCurrentState);
  const [openModal, setOpenModal] = useState(false);
  const { loading, data, refetch } = useQuery(GET_BEHAVIORS_QUERY, {
    variables: filters,
  });
  const [updateBudget, { loading: updating, data: updData, reset: updReset }] =
    useMutation(UPDATE_BUDGET);

  useEffect(() => {
    if (updData?.updateBudget) {
      setCurrentBudget(initialCurrentState);
      refetch();
      setTimeout(() => {
        updReset();
      }, 1000);
    }
  }, [updData, refetch, updReset]);

  const handleBudgetClick = (budget, action) => {
    setCurrentBudget((prev) => {
      const currentState = { ...prev, current: budget };
      if (action === "addItems" && budget.status !== "APPROVED") {
        currentState.open = true;
      }
      if (action === "approve") {
        currentState.message =
          initialCurrentState.message + " the budget:" + budget.name;
        currentState.openApprove = true;
      }
      return currentState;
    });
  };
  const handleConfirmYes = () => {
    updateBudget({
      variables: { id: currentBudget.current?.id, status: "approved" },
    });
  };
  const behaviorsList = data?.behaviorsList ?? {};
  return (
    <div className={classes.root}>
      <div className={classes.row}></div>
      <div className={classes.content}>
        <AlertConfirm
          {...currentBudget}
          open={currentBudget.openApprove}
          setOpen={() =>
            setCurrentBudget((prev) => ({ ...prev, openApprove: false }))
          }
          onConfirmYes={handleConfirmYes}
          loading={updating}
        />
        <EvaluateBehavior
          open={openModal}
          onClose={() => setOpenModal(false)}
          refetch={refetch}
        />
        <Grid container spacing={2}>
          <Grid item md={8} xs={12}>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
            >
              <Typography variant="h4">
                Behaviors to improve({behaviorsList.pageData?.length})
              </Typography>
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={() => setOpenModal(true)}
              >
                Add score to a behavior
              </Button>
            </Box>
            <CustomisedTable
              title={`Budgets(${behaviorsList.pageData?.length})`}
              data={behaviorsList.pageData}
              dataCount={behaviorsList.numPages}
              //   page={filters.pageNumber}
              columns={behaviorColumns(handleBudgetClick)}
              loading={loading}
              size="small"
              withPagination={false}
              //   rowsPerPage={filters.pageCount}
              pageOptions={[5, 10, 25, 50, 100]}
              //   handlePageChange={handlePageChange}
              //   handleRowsPerPageChange={handleRowsPerPageChange}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};
